import _ from 'lodash';
import ConstantsStorage from '../../constants/index';
import {initialUserModel} from '../models/user-model';

const ACTIONS = ConstantsStorage().USER_ACTIONS;

export default (state = initialUserModel(), action) => {
  let newState;
  switch (action.type) {
  case ACTIONS.UPDATE:
    newState = _.cloneDeep(state);
    return {...newState, ...action.data};
  case ACTIONS.CLEAR:
    return {};
  default:
    return state;
  }
};
